export default __webpack_public_path__ + "b1f9250787869c39c269fc380163d7c5.png";